/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Title from "../../ui/Title";
import Text from "../../ui/Text";
import Stack from "../../ui/Stack";

const BookingStepHeader = styled((props) => <Stack {...props} />)`
  margin-bottom: 1rem;
`;

const BookingStepList = ({ children, title, subtitle }) => {
  return (
    <>
      {(title || subtitle) && (
        <BookingStepHeader $gap="0.5rem">
          {title && <Title size="h2">{title}</Title>}
          {subtitle && <Text>{subtitle}</Text>}
        </BookingStepHeader>
      )}
      <Stack>{children}</Stack>
    </>
  );
};

export default BookingStepList;
